import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AgentUsageRow } from "../agentUsageRow";
import styles from "./Cells.module.scss";

export const ShareCell = memo(
    ({ getValue }: CellContext<ViewTableFeatures, AgentUsageRow, number>) => (
        <ViewTableCell className={styles.numberCell}>
            {Math.round(getValue() * 100)}%
        </ViewTableCell>
    ),
);

ShareCell.displayName = "ShareCell";
